module.exports = __webpack_public_path__ + "static/_colorbase_BL002-be08ede200279d9fa0a4994b093e3492.png";